import type { MagentoApiSetCheckoutFastFlowCartMutationResponse } from "@jti/magento-api-v2";
import type { ApiMagentoAddress } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const setCheckoutFastFlowCartEndpoint = (builder: MagentoApiBuilder) => ({
  setCheckoutFastFlowCart: builder.mutation<
    MagentoApiSetCheckoutFastFlowCartMutationResponse,
    {
      cartId: string;
      shippingAddress: ApiMagentoAddress;
      billingAddress: ApiMagentoAddress;
      carrierCode: string;
      methodCode: string;
    }
  >({
    query: ({ cartId, shippingAddress, billingAddress, carrierCode, methodCode }) => ({
      method: "setCheckoutFastFlowCart",
      params: [{ cartId, shippingAddress, billingAddress, carrierCode, methodCode }],
    }),
    invalidatesTags: [TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES, TAGS.SHIPPING_METHODS, TAGS.ORDER_DELIVERY_LIMITS],
  }),
});
